// extracted by mini-css-extract-plugin
export default {"btn":"ButtonPage_btn__Y28ac","icon":"ButtonPage_icon__jZRZX"};